import type { ImgHTMLAttributes } from 'react'
import { useState, useEffect, useRef } from 'react'
import { isImageValid } from 'src/utils/tools'
import { omit } from 'lodash'

interface Props extends ImgHTMLAttributes<HTMLImageElement> {
  defaultSrc?: string,
}

const Image = (props: Props) => {
  const [imgSrc, setImgSrc] = useState(props.src)
  useEffect(() => {
    setImgSrc(prev => prev === props.src ? prev : props.src)
  }, [props.src])

  const imgEL = useRef<any>(null)
  useEffect(() => {
    isImageValid(imgSrc).then(isValid => {
      if (imgEL.current) {
        const { defaultSrc = require('src/assets/common/easyImg.png') } = props
        imgEL.current.src = isValid ? imgSrc : defaultSrc
      }
    })
  }, [imgSrc])

  const imgProps = omit(props, ['defaultSrc'])
  return (
    <img
      alt={props.alt ?? ''}
      {...imgProps}
      ref={imgEL}
      src={imgSrc}
    />
  )
}

export default Image